module.exports = __webpack_public_path__ + "img/AU.39d9f050.png";